import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../static/AdminJob.css";

function AdminPostJob() {
  const navigate = useNavigate();

  const [job, setJob] = useState({
    title: "",
    company: "",
    location: "",
    salary: "",
    type: "Full-time",
    description: "",
    applyLink: ""
  });

  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setJob({ ...job, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      const existingJobs =
        JSON.parse(localStorage.getItem("qauraJobs")) || [];

      const newJob = {
        id: Date.now(),
        postedDate: new Date().toLocaleDateString(),
        ...job
      };

      localStorage.setItem(
        "qauraJobs",
        JSON.stringify([...existingJobs, newJob])
      );

      setSuccess(true);

      // Reset form
      setJob({
        title: "",
        company: "",
        location: "",
        salary: "",
        type: "Full-time",
        description: "",
        applyLink: ""
      });

      // Redirect after 1.5 sec
      setTimeout(() => {
        navigate("/jobs");
      }, 1500);

    } catch (error) {
      console.error("Error saving job:", error);
    }
  };

  return (
    <div className="admin-job-wrapper">
      <h2>Post New Job</h2>

      {success && (
        <div className="success-message">
          Job Posted Successfully 🚀
        </div>
      )}

      <form onSubmit={handleSubmit} className="job-form">
        <input
          name="title"
          placeholder="Job Title"
          value={job.title}
          onChange={handleChange}
          required
        />

        <input
          name="company"
          placeholder="Company Name"
          value={job.company}
          onChange={handleChange}
          required
        />

        <input
          name="location"
          placeholder="Location"
          value={job.location}
          onChange={handleChange}
          required
        />

        <input
          name="salary"
          placeholder="Salary Package"
          value={job.salary}
          onChange={handleChange}
          required
        />

        {/* Better Dropdown Instead of Text Input */}
        <select
          name="type"
          value={job.type}
          onChange={handleChange}
          required
        >
          <option value="Full-time">Full-time</option>
          <option value="Internship">Internship</option>
          <option value="Part-time">Part-time</option>
          <option value="Remote">Remote</option>
        </select>

        <textarea
          name="description"
          placeholder="Job Description"
          value={job.description}
          onChange={handleChange}
          required
        />

        <input
          type="url"
          name="applyLink"
          placeholder="Application Link (https://...)"
          value={job.applyLink}
          onChange={handleChange}
          required
        />

        <button type="submit">Post Job 🚀</button>
      </form>
    </div>
  );
}

export default AdminPostJob;